import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'
import { TemplateNodesDict } from 'src/exShared/types/types'

const isEmployeeCheckSection = (node: TemplateNodeSchema): boolean =>
  node.section?.isEmployeeCheck === 1

/**
 * 指定した親ノード自身、またはその祖先に従業員チェックセクションがあるか判定する。
 * 従業員チェックセクションの配下には表を作れないため、「表を追加」ボタンの表示判定に使う。
 * （直下だけでなく、従業員チェック配下にネストしたセクション内も対象にする）
 */
export const isUnderEmployeeCheckSection = (
  parentNode: TemplateNodeSchema | null,
  allNodes: TemplateNodesDict,
): boolean => {
  if (parentNode === null) return false

  // 子ノードid -> 親ノード の対応表を作り、親方向へ辿る
  const childIdToParent = new Map<number, TemplateNodeSchema>()
  for (const node of Object.values(allNodes)) {
    for (const childId of node.nodes) {
      childIdToParent.set(childId, node)
    }
  }

  let current: TemplateNodeSchema | undefined = parentNode
  while (current !== undefined) {
    if (isEmployeeCheckSection(current)) return true
    current = childIdToParent.get(current.id)
  }
  return false
}
